import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';

export default function updateFavoritesUserOptionService(
    newFavoritesNodesRaw: string[]
): Promise<void> {
    return updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['FavoriteNodes'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'StringArray',
                Value: newFavoritesNodesRaw,
            }),
        }),
    ]).then(response => {
        const responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        } else {
            return Promise.reject('updateUserConfiguration failed: ' + responseItem.ResponseClass);
        }
    });
}
